import { hasProduct } from '../lib/products';

export const CORE_NAV = [
  { id: 'dashboard', label: 'Dashboard', icon: 'dashboard', path: '/apps/dashboard' },
  { id: 'touches', label: 'Touches', icon: 'touches', path: '/apps/inbox' },
  { id: 'contacts', label: 'Contacts', icon: 'contacts', path: '/candidates' },
  { id: 'cards', label: 'Cards', icon: 'cards', path: '/apps/cards' },
  { id: 'settings', label: 'Settings', icon: 'settings', path: '/apps/settings' },
];

export const PRODUCT_NAV = [
  {
    id: 'newsletter',
    label: 'Newsletter',
    icon: 'newsletter',
    path: '/apps/newsletter',
    productId: 'newsletter',
  },
];

/** Full static list (legacy / route meta). Prefer getPlatformNav for the sidebar. */
export const PLATFORM_NAV = [
  CORE_NAV[0],
  CORE_NAV[1],
  CORE_NAV[2],
  CORE_NAV[3],
  PRODUCT_NAV[0],
  CORE_NAV[4],
];

export function getPlatformNav(enabledProducts = []) {
  const productItems = PRODUCT_NAV.filter((item) =>
    hasProduct(enabledProducts, item.productId)
  );
  return [
    CORE_NAV[0],
    CORE_NAV[1],
    CORE_NAV[2],
    CORE_NAV[3],
    ...productItems,
    CORE_NAV[4],
  ];
}

export const VIEW_META = {
  dashboard: { title: 'Dashboard', subtitle: 'Your nurture pipeline at a glance' },
  touches: { title: 'Touches', subtitle: 'AI-drafted nurture emails awaiting review' },
  contacts: { title: 'Contacts', subtitle: 'Everyone in your nurture rotation' },
  cards: { title: 'Cards', subtitle: 'Greeting templates for milestones' },
  newsletter: { title: 'Newsletter', subtitle: 'Broadcast to selected contacts' },
  settings: { title: 'Settings', subtitle: 'Profile, team, products & billing' },
};

const PLATFORM_ROUTE_PREFIXES = [
  '/apps/dashboard',
  '/apps/inbox',
  '/candidates',
  '/apps/cards',
  '/apps/newsletter',
  '/apps/settings',
];

export function isPlatformRoute(pathname = '') {
  return PLATFORM_ROUTE_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  );
}

export function getActiveNavId(pathname = '') {
  const match = PLATFORM_NAV.find(
    (item) => pathname === item.path || pathname.startsWith(`${item.path}/`)
  );
  return match?.id || 'dashboard';
}

export function getViewMeta(pathname = '') {
  const navId = getActiveNavId(pathname);
  return VIEW_META[navId] || VIEW_META.dashboard;
}

export function isFullBleedRoute(pathname = '') {
  return (
    pathname === '/apps/inbox' ||
    pathname.startsWith('/apps/inbox/') ||
    pathname === '/apps/newsletter' ||
    pathname.startsWith('/apps/newsletter/')
  );
}
